import { render, staticRenderFns } from "./editMiniGameOp.vue?vue&type=template&id=1a308a1a&lang=pug"
import script from "./editMiniGameOp.vue?vue&type=script&lang=js"
export * from "./editMiniGameOp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports